export default class SecondsTabs {
  constructor(loginContainer) {
    this._loginContainer = loginContainer;

    this._tabsContainerElement = this._loginContainer.querySelector(`.js-login-change`);
    this._callback = {};

    this._watchTabsContainerElementClick = this._watchTabsContainerElementClick.bind(this);
  }

  _watchTabsContainerElementClick(evt) {
    this._callback.elementClick(evt);
  }

  setSecondsTabsClickHandler(callback) {
    this._callback.elementClick = callback;
    this._tabsContainerElement.addEventListener(`click`, this._watchTabsContainerElementClick);
  }
}
